/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_LoadingInputs */

const en_fw_bm_loading = /** @type {(inputs: Fw_Bm_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the benchmark…`)
};

const id_fw_bm_loading = /** @type {(inputs: Fw_Bm_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat benchmark…`)
};

/**
* | output |
* | --- |
* | "Loading the benchmark…" |
*
* @param {Fw_Bm_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_loading = /** @type {((inputs?: Fw_Bm_LoadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_LoadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_loading(inputs)
	return en_fw_bm_loading(inputs)
});